<template>
  <div class="editor" :class="panel ? '_panel' : null">
    <EditorMenuBar v-if="panel"
                   :editor="editor"
                   v-slot="{ commands, isActive }">
      <div class="editor__header">
        <div class="editor__group">
          <button @click.prevent="commands.undo"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-undo"/>
          </button>
          <button @click.prevent="commands.redo"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-redo"/>
          </button>
        </div>
        <!--        <div class="editor__group">-->
        <!--          <button class="editor__btn  reset-button">-->
        <!--            <BaseSvg name="ico-editor-align-left"/>-->
        <!--          </button>-->
        <!--          <button class="editor__btn  reset-button">-->
        <!--            <BaseSvg name="ico-editor-align-center"/>-->
        <!--          </button>-->
        <!--          <button class="editor__btn  reset-button">-->
        <!--            <BaseSvg name="ico-editor-align-right"/>-->
        <!--          </button>-->
        <!--          <button class="editor__btn  reset-button">-->
        <!--            <BaseSvg name="ico-editor-align-justify"/>-->
        <!--          </button>-->
        <!--        </div>-->
        <div v-if="useHeadings" class="editor__group">
          <button :class="{ 'is-active': isActive.paragraph() }"
                  @click.prevent="commands.paragraph"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-p"/>
          </button>
          <button :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                  @click.prevent="commands.heading({ level: 2 })"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-h1"/>
          </button>
          <button :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                  @click.prevent="commands.heading({ level: 3 })"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-h2"/>
          </button>
          <button :class="{ 'is-active': isActive.heading({ level: 4 }) }"
                  @click.prevent="commands.heading({ level: 4 })"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-h3"/>
          </button>
          <button :class="{ 'is-active': isActive.heading({ level: 5 }) }"
                  @click.prevent="commands.heading({ level: 5 })"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-h4"/>
          </button>
        </div>
        <div class="editor__group">
          <button @click.prevent="commands.bold"
                  :class="{ '_active': isActive.bold() }"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-bold"/>
          </button>
          <button @click.prevent="commands.italic"
                  :class="{ '_active': isActive.italic() }"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-italic"/>
          </button>
          <button @click.prevent="commands.strike"
                  :class="{ '_active': isActive.strike() }"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-line-throw"/>
          </button>
        </div>
        <div class="editor__group">
          <button @click.prevent="commands.bullet_list"
                  :class="{ '_active': isActive.bullet_list() }"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-ul"/>
          </button>
          <button @click.prevent="commands.ordered_list"
                  :class="{ '_active': isActive.ordered_list() }"
                  class="editor__btn  reset-button">
            <BaseSvg name="ico-editor-ol"/>
          </button>
        </div>
      </div>
    </EditorMenuBar>
    <div class="editor__content">
      <div v-if="placeholder && !value" class="editor__placeholder absolute">{{ placeholder }}</div>
      <EditorContent
        :editor="editor"
        :readonly="readonly"
        class="editor__text  text"
      />
    </div>
    <div style="display: none !important;">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-undo">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path
          d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-redo">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path
          d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-bold">
        <path
          d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-italic">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-line-throw">
        <path
          d="M6.85,7.08C6.85,4.37,9.45,3,12.24,3c1.64,0,3,0.49,3.9,1.28c0.77,0.65,1.46,1.73,1.46,3.24h-3.01 c0-0.31-0.05-0.59-0.15-0.85c-0.29-0.86-1.2-1.28-2.25-1.28c-1.86,0-2.34,1.02-2.34,1.7c0,0.48,0.25,0.88,0.74,1.21 C10.97,8.55,11.36,8.78,12,9H7.39C7.18,8.66,6.85,8.11,6.85,7.08z M21,12v-2H3v2h9.62c1.15,0.45,1.96,0.75,1.96,1.97 c0,1-0.81,1.67-2.28,1.67c-1.54,0-2.93-0.54-2.93-2.51H6.4c0,0.55,0.08,1.13,0.24,1.58c0.81,2.29,3.29,3.3,5.67,3.3 c2.27,0,5.3-0.89,5.3-4.05c0-0.3-0.01-1.16-0.48-1.94H21V12z"/>
        <rect fill="none" height="24" width="24"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-ul">
        <path
          d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"/>
        <path d="M0 0h24v24H0V0z" fill="none"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-ol">
        <path
          d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-p">
        <path
          d="M9.67,13.75v5.83H12V6.75h2.33V19.58h2.33V6.75H19V4.42H9.67a4.67,4.67,0,1,0,0,9.33Z"/>
        <path d="M0,0H24V24H0Z" style="fill:none"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-h1">
        <title>h1</title>
        <path d="M0,0H24V24H0Z" style="fill:none"/>
        <path d="M12.12,18.25H9.22v-5H4.93v5H2V6.16H4.93V11H9.22V6.16h2.9Z"/>
        <path d="M20,18.25H17.18V9.32l-2.76.81V8l5.3-1.83H20Z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-h2">
        <path d="M0,0H24V24H0Z" style="fill:none"/>
        <path d="M12.12,18.25H9.22v-5H4.93v5H2V6.16H4.93V11H9.22V6.16h2.9Z"/>
        <path
          d="M22.22,18.25H13.79V16.42l3.88-4.08a4.63,4.63,0,0,0,1.44-2.6,1.8,1.8,0,0,0-.34-1.19,1.21,1.21,0,0,0-1-.41,1.23,1.23,0,0,0-1,.54,2.24,2.24,0,0,0-.4,1.36h-2.8A4,4,0,0,1,14.1,8a3.9,3.9,0,0,1,1.54-1.47A4.59,4.59,0,0,1,17.85,6a4.51,4.51,0,0,1,3,.9,3.23,3.23,0,0,1,1.06,2.6,3.76,3.76,0,0,1-.27,1.39,6.1,6.1,0,0,1-.83,1.42,20.9,20.9,0,0,1-1.81,2l-1.56,1.8h4.76Z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-h3">
        <title>h3</title>
        <path d="M0,0H24V24H0Z" style="fill:none"/>
        <path d="M12.12,18.25H9.22v-5H4.93v5H2V6.16H4.93V11H9.22V6.16h2.9Z"/>
        <path
          d="M16.35,11h1.32A1.37,1.37,0,0,0,19.23,9.5a1.33,1.33,0,0,0-.37-1,1.42,1.42,0,0,0-1.05-.38,1.52,1.52,0,0,0-1,.32,1,1,0,0,0-.41.81h-2.8a2.86,2.86,0,0,1,.53-1.7,3.51,3.51,0,0,1,1.47-1.17A5,5,0,0,1,17.71,6a5,5,0,0,1,3.17.92A3.06,3.06,0,0,1,22,9.44a2.55,2.55,0,0,1-.48,1.47A3.4,3.4,0,0,1,20.16,12a3.25,3.25,0,0,1,1.51,1.06,2.79,2.79,0,0,1,.55,1.76A3.12,3.12,0,0,1,21,17.45a5.17,5.17,0,0,1-3.27,1A5.35,5.35,0,0,1,15.5,18,3.46,3.46,0,0,1,14,16.71a3.25,3.25,0,0,1-.52-1.82h2.81a1.26,1.26,0,0,0,.45,1,1.58,1.58,0,0,0,1.1.41A1.66,1.66,0,0,0,19,15.85a1.37,1.37,0,0,0,.44-1A1.61,1.61,0,0,0,19,13.5a1.91,1.91,0,0,0-1.26-.38H16.35Z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ico-editor-h4">
        <title>h4</title>
        <path d="M0,0H24V24H0Z" style="fill:none"/>
        <path d="M12.12,18.25H9.22v-5H4.93v5H2V6.16H4.93V11H9.22V6.16h2.9Z"/>
        <path
          d="M21.18,13.53h1.23v2.16H21.18v2.56h-2.8V15.69H13.71L13.54,14l4.84-7.79v0h2.8Zm-5,0h2.17V9.81l-.17.28Z"/>
      </svg>
    </div>
  </div>
</template>

<script>
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
  import {
    // Blockquote,
    // CodeBlock,
    // HardBreak,
    Heading,
    // HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    // TodoItem,
    // TodoList,
    // Code,
    // Link,
    Underline,
    Bold,
    Italic,
    Strike,
    History,
  } from 'tiptap-extensions'

  export default {
    components: {
      EditorContent,
      EditorMenuBar,
    },
    props: {
      value: String,
      readonly: Boolean,
      placeholder: String,
      panel: {
        type: Boolean,
        default: true
      },
      triggerOnInput: {
        type: Boolean,
        default: false
      },
      useHeadings: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        prevValue: null,
        editor: new Editor({
          extensions: [
            new Heading(this.useHeadings ? {levels: [2, 3, 4, 5]} : undefined),
            new BulletList(),
            new ListItem(),
            new OrderedList(),
            new Underline(),
            new Bold(),
            new Italic(),
            new Strike(),
            new History(),
          ],
          content: this.value,
          onUpdate: this.onUpdate,
          onBlur: () => {
           this.$emit('blur')
          }
        })
      }
    },
    methods: {
      setContent() {
        if(this.prevValue === this.value) {
          return
        }
        this.editor.setContent(this.value)
      },
      onUpdate() {
        let html = this.editor.getHTML()
        html = (html === '<p></p>') ? null : html

        this.prevValue = html
        this.$emit('input', html)
      }
    },
    watch: {
      value() {
        this.setContent()
      }
    },
    created() {

    },
    beforeDestroy() {
      // Always destroy your editor instance when it's no longer needed
      this.editor.destroy()
    }
  }
</script>
